import { useContext } from "react";
import { AddOnsContext } from "../state/contexts";

function useAddOns() {
  return useContext(AddOnsContext);
}

export default useAddOns;
